import { IsString, IsOptional, MaxLength, IsArray, MinLength } from 'class-validator';

export class ProductCheckpointSearchDTO {

    @IsOptional()
    @IsString()
    @MaxLength(50)
    title: string;

    @IsOptional()
    @IsString()
    @MaxLength(50)
    description: string;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    products: Array<string>;

}
